/* SY — grade da coleção: a lista "Trier par" abre sob o botão, fecha com clique fora ou Esc, e escolher uma
   opção leva à mesma coleção na ordem escolhida (voltando à página 1, como a referência). */
(() => {
  if (window.syColecao) return;
  window.syColecao = true;

  const fechar = (exceto) => {
    document.querySelectorAll('[data-sy-sort][aria-expanded="true"]').forEach((botao) => {
      if (botao === exceto) return;
      botao.setAttribute('aria-expanded', 'false');
      const lista = document.getElementById(botao.getAttribute('aria-controls'));
      if (lista) lista.hidden = true;
    });
  };

  document.addEventListener('click', (e) => {
    const botao = e.target.closest('[data-sy-sort]');
    if (botao) {
      const lista = document.getElementById(botao.getAttribute('aria-controls'));
      const abrir = botao.getAttribute('aria-expanded') !== 'true';
      fechar(botao);
      botao.setAttribute('aria-expanded', String(abrir));
      if (lista) lista.hidden = !abrir;
      return;
    }

    const opcao = e.target.closest('.sy-popover-listbox__option');
    if (opcao) {
      const caixa = opcao.closest('facet-sort-by');
      const padrao = caixa ? caixa.dataset.padrao : '';
      const url = new URL(window.location.href);
      url.searchParams.delete('page');
      if (padrao && opcao.value === padrao) url.searchParams.delete('sort_by');
      else url.searchParams.set('sort_by', opcao.value);
      opcao.closest('x-listbox').querySelectorAll('[role="option"]').forEach((o) => o.setAttribute('aria-selected', String(o === opcao)));
      const valor = caixa && caixa.querySelector('.sy-text-with-icon .sy-reversed-link');
      if (valor) valor.textContent = opcao.textContent.trim();
      fechar();
      const grade = opcao.closest('.sy-collection');
      if (grade) grade.classList.add('is-loading');
      window.location.href = url.toString();
      return;
    }

    if (!e.target.closest('x-popover.sy-sort-pop')) fechar();
  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') fechar(); });
})();
